// Библиотеки и внешние зависимости
import { useState, useEffect, createContext, useReducer } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import Cookies from 'universal-cookie';
import { returnMenu } from './menu';

// Компоненты UI
import LoadingPage from './components/LoadingPage/LoadingPage';
import { MainMenu } from '@lk-gtcom/ecomlab-components';
import { Modal } from './components/Modal/Modal';
import { ModalAddEmployee } from './components/Modal/ModalAddEmployee/ModalAddEmployee';
import { ModalAddRole } from './components/Modal/ModalAddRole/ModalAddRole';
import { ModalKnowledgeBase } from './components/Modal/ModalKnowledgeBase/ModalKnowledgeBase';
import { SnackbarMui } from './components/SnackbarMui/SnackbarMui';
import { Cookie, ACCEPT_COOKIE } from './components/Cookie/Cookie';
import { EditProduct } from './pages/EditProduct/EditProduct';
import { Footer } from './components/Footer/Footer';
import { HeaderMain } from './components/HeaderMain/HeaderMain';
import { NotActive } from '@lk-gtcom/ecomlab-components';
import { ProductsList } from './pages/ProductsList/ProductsList';
import { TopKeywords } from './pages/TopKeywords/TopKeywords';
import { PushNotifications } from './components/PushNotifications/PushNotifications';

// Сложные компоненты
import { AddProductVer3 } from './pages/AddProductVer3/AddProductVer3';
import { AnaliticsReview } from './pages/AnaliticsReview/AnaliticsReview';
import { AnalysisByBrand } from './pages/AnalysisByBrand/AnalysisByBrand';
import { AnalysisByCategory } from './pages/AnalysisByCategory/AnalysisByCategory';
import { AnalysisBySaleType } from './pages/AnalysisBySaleType/AnalysisBySaleType';
import { AnalysisBySellers } from './pages/AnalysisBySellers/AnalysisBySellers';
import { AnalysisCategory } from './pages/AnalysisCategory/AnalysisCategory';
import { AnalysisPlatformByBrand } from './pages/AnalysisPlatformByBrand/AnalysisPlatformByBrand';
import { AnalysisPlatformBySellers } from './pages/AnalysisPlatformBySellers/AnalysisPlatformBySellers';
import { AnalysisSearchQuery } from './pages/AnalysisSearchQuery/AnalysisSearchQuery';
import { AutomationResponses } from './pages/AutomationResponses/AutomationResponses';
import { Deliveries } from './pages/Deliveries/Deliveries';
import { InstallationDRR } from './pages/InstallationDRR/InstallationDRR';
import { NicheSelection } from './pages/NicheSelection/NicheSelection';
import { OrderManagement } from './pages/OrderManagement/OrderManagement';
import { ProductCardExtended } from './pages/ProductCardExtended/ProductCardExtended';
import { ProductsListMasterProduct } from './pages/ProductsListMasterProduct/ProductsListMasterProduct';
import { SetPriceAndMargin } from './pages/SetPriceAndMarginMaster/SetPriceAndMargin';
import { SetPriceAndMarginMasterProduct } from './pages/SetPriceAndMarginMasterProduct/SetPriceAndMarginMasterProduct';
import { SetRemainingGoods } from './pages/SetRemainingGoods/SetRemainingGoods';
import { SetRemainingGoodMasterProduct } from './pages/SetRemainingGoodMasterProduct/SetRemainingGoodMasterProduct';
import { WorkWithReviews } from './pages/WorkWithReviews/WorkWithReviews';
import { SkuSearch } from './components/SkuSearch/SkuSearch';
import { Limit } from './components/Limit/Limit';

// Документы
import { ActService } from './components/Documents/ActService/ActService';
import { ActVerification } from './components/Documents/ActVerification/ActVerification';
import { Invoice } from './components/Documents/Invoice/Invoice';
import { InvoiceWithSignature } from './components/Documents/InvoiceWithSignature/InvoiceWithSignature';

// Страницы
import { AnalyticsPage } from './pages/AnalyticsPage/AnalyticsPage';
import { Anomalies } from './pages/Anomalies/Anomalies';
import { CalculationDelivery } from './pages/CalculationDelivery/CalculationDelivery';
import { Calendar } from './pages/Calendar/Calendar';
import { ChatBot } from './pages/ChatBot/ChatBot';
import { ChatMessagePage } from './pages/ChatMessage/ChatMessagePage';
import { CheckingOVH } from './pages/CheckingOVH/CheckingOVH';
import { CrossAnalytics } from './pages/CrossAnalytics/CrossAnalytics';
import { Hint } from './pages/Hint/Hint';
import { Landing } from './pages/Landing/Landing';
import { MainDirectory } from './pages/MainDirectory/MainDirectory';
import { MarketingOzon } from './pages/MarketingOzon/MarketingOzon';
import { MassImprovement } from './pages/MassImprovement/MassImprovement';
import { NotificationsVer2 } from './pages/NotificationsVer2/NotificationsVer2';
import { Page404 } from './pages/Page404/Page404';
import { PromotionsPage } from './pages/StockPage/PromotionsPage';
import { SettingCostPrice } from './pages/SettingCostPrice/SettingCostPrice';
import { SettingMasterProduct } from './pages/SettingMasterProduct/SettingMasterProduct';
import { Settings } from './pages/Settings/Settings';
import { SocialNetwork } from './pages/SocialNetwork/SocialNetwork';
import { TaskPage } from './pages/TaskLogic/TaskPage/TaskPage';
import { CRMPage } from './pages/CRMLogic/CRMPage/CRMPage';
import { TicketPage } from './pages/TicketLogic/TicketPage/TicketPage';
import { Wiki } from './pages/Wiki/Wiki';
import { AddCompetitors } from './pages/AddCompetitors/AddCompetitors';
import { CreateCampaignFromRules } from './pages/CreateCampaignFromRules/CreateCampaignFromRules';
import { Repricing } from './pages/Repricing/Repricing';
import { AnalyticsByMetrics } from './pages/AnalyticsByMetrics/AnalyticsByMetrics';
import { AutocompleteTemplatesAi } from './pages/AutocompleteTemplatesAi/AutocompleteTemplatesAi';
import { StatisticsInReviews } from './pages/StatisticsInReviews/StatisticsInReviews';
import { AIAnalysis } from './pages/AIAnalysis/AIAnalysis';
import { MaintainingMarginality } from './pages/MaintainingMarginality/MaintainingMarginality';
import { LowHighAnalysis } from './pages/LowHighAnalysis/LowHighAnalysis';
import { ViewСompetitors } from './pages/ViewСompetitors/ViewСompetitors'
import { ViewСompetitors2 } from './pages/ViewСompetitors2/ViewСompetitors2'
import { SupplyList } from './pages/SupplyList/SupplyList';
import { Rules } from './pages/Rules/Rules';
import { WorkingWithReturns } from './pages/WorkingWithReturns/WorkingWithReturns';
import { AutomationReturns } from './pages/AutomationReturns/AutomationReturns';
import TariffNotActive from './components/TariffNotActive/TariffNotActive';

// LaModa
import { ByCollectionErrors } from './pages/LaModa/ByCollectionErrors/ByCollectionErrors';
import { ByUpdates } from './pages/LaModa/ByUpdates/ByUpdates';
import { ForAllProducts } from './pages/LaModa/ForAllProducts/ForAllProducts';
import { OnNewProducts } from './pages/LaModa/OnNewProducts/OnNewProducts';
import { RequestLogs } from './pages/LaModa/RequestLogs/RequestLogs';
import { ByLinks } from './pages/LaModa/ByLinks/ByLinks';

// Modal
import { ModalAddContactCRM } from './pages/CRMLogic/CRMList/ContactCRM/ModalAddContactCRM/ModalAddContactCRM';
import { ModalAddCompanyCRM } from './pages/CRMLogic/CRMList/CompanyCRM/ModalAddCompanyCRM/ModalAddCompanyCRM';
import { ModalAddContractCRM } from './pages/CRMLogic/CRMList/ContractCRM/ModalAddContractCRM/ModalAddContractCRM';
import { ModalAddServicesCRM } from './pages/CRMLogic/CRMList/ServicesCRM/ModalAddServicesCRM/ModalAddServicesCRM';
import { NotificationsError } from './pages/NotificationsError/NotificationsError';

// Вспомогательные модули
import { refresh, parseJwt, TOKEN_LIFETIME_MS } from './common/authHelper';
import customHeaders, { getSpace } from './common/headers';
import analyticRoutes from './pages/AnalyticsPage/routes';
import { setUpFetchProxy } from './microServices/api/fetch';
import { WidgetChat } from './components/WidgetChat/WidgetChat';
import ChatModal from './components/Modal/ChatModal/ChatModal';
import { useCheckPathAccess } from './common/useCheckPathAccess';

// Изображения
import user_icon from './common/img/bx-user.svg';
import user_circle_icon from './common/img/bx-user-circle.svg';

// Сторы
import useModal from './store/modal';
import useGeneralStore from './store/general';
import settingsConnectionReducer, { defaultState } from './pages/SettingsConnection/actions';

// Тест
import { Test } from './pages/Test/Test';

export const BASE_ROUTE = '';

function App() {
  const path = useParams();
  const client_id = localStorage.getItem('client_id');
  const navigate = useNavigate();
  const [connectionIds, setConnectionIds] = useState([]);

  const [isModalFeedback, setIsModalFeedback] = useState(false);

  const [showNotificationBox, setShowNotificationBox] = useState(false);
  const [activeContent, setActiveContent] = useState('');
  const [connectedModal, setConnectedModal] = useState(false);
  const [isOpenMainMenu, setIsOpenMainMenu] = useState(false);
  const [editableConnection, dispatch] = useReducer(
    settingsConnectionReducer,
    defaultState
  );

  // Проверка доступа
  // useCheckPathAccess()

  const {
    isModalActive,
    setIsModalActive,
    isModalAddEmployee,
    setIsModalAddEmployee,
  } = useModal(
    useShallow((state) => ({
      isModalActive: state.isModalActive,
      setIsModalActive: state.setIsModalActive,
      isModalAddEmployee: state.isModalAddEmployee,
      setIsModalAddEmployee: state.setIsModalAddEmployee,
    }))
  );

  const openConnectionModalById = (ids) => {
    setConnectionIds(ids);
    setIsModalActive(true);
  };

  let pathBread = '';
  const [paths, setPaths] = useState([]);
  const [pathsWebName, setPathsWebName] = useState([]);
  const [description, setDescription] = useState('');
  const [currentArticle, setCurrentArticle] = useState({});
  const [queryFeddbacks, setQueryFeedbacks] = useState('')


  const [showCookie, setShowCookie] = useState(true);
  const [activeLang, setActiveLang] = useState(
    () => localStorage.getItem('lang') ?? 'ru'
  );
  const {
    selectedSpace,
    setSelectedSpace,
    spaceList,
    setSpaceList,
    isModalCompany,
    setIsModalCompany,
    isModalContact,
    setIsModalContact,
    isModalContract,
    setIsModalContract,
    isModalServices,
    setIsModalServices,
    currentCompany,
    setCurrentCompany,
    currentContact,
    setCurrentContact,
    currentContract,
    setCurrentContract,
    currentServices,
    setCurrentServices,
    currentDeal,
    setCurrentDeal,
    setNotifCount,
    isModalAddEmployees,
    setIsModalAddEmployees,
    isModalNotificationsError,
    counterError,
    setCounterError,
    statusTariff,
    isModalRole,
    setIsModalRole
  } =
    useGeneralStore(
      useShallow((state) => ({
        selectedSpace: state.selectedSpace,
        setSelectedSpace: state.setSelectedSpace,
        spaceList: state.spaceList,
        setSpaceList: state.setSpaceList,
        isModalCompany: state.isModalCompany,
        setIsModalCompany: state.setIsModalCompany,
        isModalContact: state.isModalContact,
        setIsModalContract: state.setIsModalContract,
        isModalContract: state.isModalContract,
        setIsModalContact: state.setIsModalContact,
        isModalServices: state.isModalServices,
        setIsModalServices: state.setIsModalServices,
        currentContact: state.currentContact,
        setCurrentContact: state.setCurrentContact,
        currentContract: state.currentContract,
        setCurrentContract: state.setCurrentContract,
        currentServices: state.currentServices,
        setCurrentServices: state.setCurrentServices,
        currentCompany: state.currentCompany,
        setCurrentCompany: state.setCurrentCompany,
        currentDeal: state.currentDeal,
        setCurrentDeal: state.setCurrentDeal,
        isChangeNotification: state.isChangeNotification,
        setIsChangeNotification: state.setIsChangeNotification,
        notifCount: state.notificationCounter,
        setNotifCount: state.setNotificationCounter,
        isModalAddEmployees: state.isModalAddEmployees,
        setIsModalAddEmployees: state.setIsModalAddEmployees,
        isModalNotificationsError: state.isModalNotificationsError,
        setIsModalNotificationsError: state.setIsModalNotificationsError,
        counterError: state.counterError,
        setCounterError: state.setCounterError,
        statusTariff: state.statusTariff,
        isModalRole: state.isModalRole,
        setIsModalRole: state.setIsModalRole
      }))
    );


  const headers = { ...customHeaders, ...getSpace(selectedSpace) };

  // Каунтер сообщений
  const fetchNotificationsCount = () => {
    let url = ` https://portals.ecomru.ru/api/v2/article/get_count_unread_msg?status=unreaded`

    fetch(url, { method: 'GET', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => setNotifCount(json))
      .catch((err) => console.error(err));
  };

  // Каунтер ошибок
  const fetchErrorCount = () => {
    let url = `https://apps1.ecomru.ru:4455/error-notifications/unread-counter-by-services`

    fetch(url, { method: 'GET', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => setCounterError(json))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    let intervalId;

    intervalId = setInterval(() => {
      fetchNotificationsCount();
    }, 10000);

    return () => {
      clearInterval(intervalId);
    };
  }, [selectedSpace]);

  useEffect(() => {
    if (!isModalNotificationsError) {
      fetchErrorCount();
    }
  }, [selectedSpace, isModalNotificationsError]);

  useEffect(() => {
    let intervalId;

    intervalId = setInterval(() => {
      fetchErrorCount();
    }, 10000);

    return () => {
      clearInterval(intervalId);
    };
  }, [selectedSpace]);

  const [activeItems, setActiveItems] = useState(returnMenu(selectedSpace)[0]);
  const [activeSubItems, setActiveSubItems] = useState(returnMenu(selectedSpace)[0]?.subItems[0]);
  const [optionList, setOptionsList] = useState([]);

  const [isEditSpace, setIsEditSpace] = useState(false);

  // Modal
  const [isModalKnowledgeBase, setIsModalKnowledgeBase] = useState(false);
  const [isModalCreatingNewSpace, setIsModalCreatingNewSpace] = useState(false);
  const [isModalChat, setIsModalChat] = useState(false)
  const [isModalUnboardingForSpace, setIsModalUnboardingForSpace] = useState(false);

  const { currentSpace, setCurrentSpace } =
    useGeneralStore(
      useShallow((state) => ({
        currentSpace: state.currentSpace,
        setCurrentSpace: state.setCurrentSpace
      }))
    );

  // Получение пространств
  const fetchGetSpace = () => {
    const abortController = new AbortController();

    const url = `https://apps0.ecomru.ru:4242/api/v2/space/list?role=all`;

    fetch(url, { headers, signal: abortController.signal })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        if (json?.data) {
          setSpaceList(json?.data);
        }
      })
      .catch((err) => console.error(err))
      .finally((e) => {
        // setLoad(false)
      });
    return abortController;
  };

  useEffect(() => {
    setOptionsList(
      spaceList?.data?.map(({ id, name, author }) => {
        return {
          label: (
            <p className="option-space">
              <img
                src={client_id == author?.id ? user_circle_icon : user_icon}
              />
              <span>{name}</span>
            </p>
          ),
          label: name,
          value: id,
          author: author,
        };
      })
    );
  }, [spaceList]);

  useEffect(() => {
    if (!selectedSpace?.value && optionList?.length < 1) {
      setIsModalUnboardingForSpace(true);
    }
  }, [optionList]);



  useEffect(() => {
    const pricePlan = localStorage.getItem('ref-pricePlan');
    const redirect_page = localStorage.getItem('ref-page');

    if (pricePlan && redirect_page) {
      navigate(`${redirect_page}?ref-pricePlan=${pricePlan}`);
    }
  }, []);

  useEffect(() => {
    document.body.scrollTop = 0;
  }, [navigate]);

  useEffect(() => {
    fetchGetSpace();
  }, []);

  const setNavigation = (cookies) => {
    const isAccount = localStorage.getItem('not_one_account');
    const auth_token = cookies.get('auth');

    if (auth_token) {
      if (isAccount) {
        if (path['*'] === '' && activeContent !== 'Admin') {
          // navigate(`/analytics/date`);
          cookies.remove('refresh', { path: 'landing/charts' })
        }
      } else {
        //перенаправляет постоянно на лендинг, что мешает постоянно и препятствует корректной работе меню
        //ломает логику пунктов меню,
        //navigate("/analytics/date");
      }
    } else {
      navigate('../auth');
    }
  };

  useEffect(() => {
    // Проверяем, что мы на корневом пути и нет других параметров
    const currentPath = window.location.pathname;

    // Если путь точно равен '/' (или пустая строка после BASE_ROUTE)
    if (currentPath === '/' || currentPath === '') {
      navigate('/landing/charts');
    }
  }, [navigate]);

  useEffect(() => {
    sessionStorage.removeItem('taskProjectId');
    sessionStorage.removeItem('ticketProjectId');
    sessionStorage.removeItem('crmProjectId');
    sessionStorage.removeItem('taskProjectName');
    const cookies = new Cookies();

    const userAgent = `userAgent: ${window.navigator.userAgent.replace(
      ',',
      ';'
    )}`;
    const userAgentData = window.navigator?.userAgentData;
    let mobile,
      platform = null;
    if (userAgentData) {
      mobile = userAgentData?.mobile;
      platform = userAgentData?.platform;
    } else {
      platform = userAgent?.platform;
    }
    mobile = `mobile: ${mobile}`;
    platform = `platform: ${platform}`;
    let { height, width } = window.screen;
    height = `height: ${height}`;
    width = `width: ${width}`;
    cookies.set(
      'client_info',
      `${userAgent}, ${mobile}, ${platform}, ${height}, ${width}`
    );

    setUpFetchProxy();

    const authLocal = localStorage.getItem('auth');
    const refreshLocal = localStorage.getItem('refresh');
    const acceptCookie = cookies.get(ACCEPT_COOKIE);

    if (acceptCookie) setShowCookie(false);

    if (authLocal || refreshLocal) {
      cookies.remove('auth', { path: '/' });
      cookies.remove('refresh', { path: '/' });

      let accessTokenExpiryDate = new Date();
      let refreshTokenExpiryDate = new Date();

      const { exp: refreshExpTime } = parseJwt(refreshLocal);

      accessTokenExpiryDate.setTime(
        accessTokenExpiryDate.getTime() + TOKEN_LIFETIME_MS
      );
      refreshTokenExpiryDate.setTime(
        refreshTokenExpiryDate.getTime() + refreshExpTime
      );

      cookies.set('auth', authLocal, {
        expires: accessTokenExpiryDate,
        path: '/',
      });

      cookies.set('refresh', refreshLocal, {
        expires: refreshTokenExpiryDate,
        path: '/',
      });

      localStorage.removeItem('auth');
      localStorage.removeItem('refresh');
      // window.location.reload();
    }

    const authToken = cookies.get('auth');
    const refreshToken = cookies.get('refresh');

    if (!authToken && refreshToken) {
      refresh({
        token: refreshToken,
        onError: () => navigate('../auth'),
        shouldStayOnPage: true,
      });
      return;
    }

    setNavigation(cookies);
  }, []);

  return (
    <>
      <LoadingPage />

      <PushNotifications />

      <main className="main">

        <ConnectionsContext.Provider value={{ editableConnection, dispatch }}>
          <div className="content">
            <NotificationContext.Provider
              value={{
                showNotificationBox,
                setShowNotificationBox,
              }}
            >
              {isModalNotificationsError &&
                <NotificationsError
                  isModal={true}
                />}

              {showCookie && <Cookie setIsModal={(e) => setShowCookie(e)} />}


              {isModalKnowledgeBase && (
                <ModalKnowledgeBase
                  sidebarItems={returnMenu(selectedSpace)}
                  isModal={isModalKnowledgeBase}
                  setIsModal={(e) => setIsModalKnowledgeBase(e)}
                />
              )}

              {isModalAddEmployees &&
                <ModalAddEmployee
                  currentSpace={currentSpace}
                  spaceList={spaceList}
                  setShowModal={(e) => setIsModalAddEmployees(e)}
                // fetchGetEmployees={(e) => fetchGetEmployees(e)}
                />}

              {/* Назначение ролей */}
              {isModalRole && <ModalAddRole
                setIsModal={(e) => setIsModalRole(e)}
              />}

              {/* Добавление сотрудника */}
              {isModalAddEmployee && (
                <ModalAddEmployee
                  setShowModal={setIsModalAddEmployee}
                  spaceList={spaceList}
                />
              )}

              {isModalContact && <ModalAddContactCRM
                currentDeal={currentDeal}
                currentContact={currentContact}
                setCurrentContact={setCurrentContact}
                setIsModal={setIsModalContact}
                setCurrentDeal={setCurrentDeal}
              />}

              {isModalCompany && <ModalAddCompanyCRM
                currentDeal={currentDeal}
                currentCompany={currentCompany}
                setCurrentCompany={setCurrentCompany}
                setIsModal={setIsModalCompany}
                setCurrentDeal={setCurrentDeal}
              />}

              {isModalContract && <ModalAddContractCRM
                currentDeal={currentDeal}
                currentContract={currentContract}
                setCurrentContract={setCurrentContract}
                setIsModal={setIsModalContract}
                setCurrentDeal={setCurrentDeal}
              />}

              {isModalServices && <ModalAddServicesCRM
                currentServices={currentServices}
                setCurrentServices={setCurrentServices}
                setIsModal={setIsModalServices}
              />}

              {/* Шапка сайта */}
              <HeaderMain
                spaceList={spaceList}
                selectedSpace={selectedSpace}
                setSelectedSpace={setSelectedSpace}
                activeContent={activeContent}
                setActiveItems={setActiveItems}
                setActiveSubItems={setActiveSubItems}
                setIsModalKnowledgeBase={setIsModalKnowledgeBase}
                setIsModalCreatingNewSpace={setIsModalCreatingNewSpace}
                setIsModalActive={setIsModalActive}
                isModalUnboardingForSpace={isModalUnboardingForSpace}
                setIsModalUnboardingForSpace={setIsModalUnboardingForSpace}
                setIsModalAddEmployee={setIsModalAddEmployee}
                isOpenMainMenu={isOpenMainMenu}
                setIsOpenMainMenu={setIsOpenMainMenu}
                setIsEditSpace={setIsEditSpace}
                setIsModalChat={setIsModalChat}
              />

              {/* Основное меню */}
              <MainMenu
                menu={returnMenu(selectedSpace)}
                activeItems={activeItems}
                setActiveItems={setActiveItems}
                activeSubItems={activeSubItems}
                setActiveSubItems={setActiveSubItems}
                onCloseMenu={() => setIsOpenMainMenu(false)}
                isOpen={isOpenMainMenu}
                queryFeddbacks={queryFeddbacks}
                counterError={counterError}
                // activeTariff={statusTariff}
                activeTariff={(selectedSpace?.value == 4211) ? statusTariff : true}
              />

              {/* Основной контейнер */}
              <div className="main-container">
                <Limit
                  activeItems={activeItems}
                  activeSubItems={activeSubItems}
                />
                <Routes>

                  {/* Лендинги */}

                  <Route path="/landing/*" element={<Landing setIsModalActive={(e) => setIsModalActive(e)} />} />

                  {/* Чат */}

                  <Route path="/chat" element={<ChatMessagePage />} />

                  {/* Настройки */}

                  <Route path="/settings/*" element={
                    <Settings
                      isEditSpace={isEditSpace}
                      setIsModalRole={setIsModalRole}
                      isModalCreatingNewSpace={isModalCreatingNewSpace}
                      setActiveItems={setActiveItems}
                      setActiveSubItems={setActiveSubItems}
                      isModalFeedback={isModalFeedback}
                      setIsModalFeedback={setIsModalFeedback}
                      setConnectedModal={setConnectedModal}
                      setIsModalActive={setIsModalActive}
                      setIsModalCreatingNewSpace={setIsModalCreatingNewSpace}
                      setIsEditSpace={setIsEditSpace}
                      isModalActive={isModalActive}
                      fetchGetSpace={fetchGetSpace}
                      spaceList={spaceList}
                      currentSpace={currentSpace}
                      setCurrentSpace={setCurrentSpace}
                    />
                  }
                  />

                  {/* LaModa */}

                  <Route path={`/by_collection_errors/*`} element={<ByCollectionErrors />} />

                  <Route path={`/by-updates/*`} element={<ByUpdates />} />

                  <Route path={`/for-all-products/*`} element={<ForAllProducts />} />

                  <Route path={`/on-new-products/*`} element={<OnNewProducts />} />

                  <Route path={`/request-logs/*`} element={<RequestLogs />} />

                  <Route path={`/by-links`} element={<ByLinks />} />


                  {/* Аналитика */}

                  <Route path={`/${analyticRoutes.analytics}/*`} element={<AnalyticsPage
                    activeSubItems={activeSubItems}
                    route={analyticRoutes.analytics}
                  />
                  }
                  />

                  <Route path={`/${analyticRoutes.marginality_analysis}/*`} element={
                    <AnalyticsPage
                      activeSubItems={activeSubItems}
                      route={analyticRoutes.marginality_analysis}
                    />
                  }
                  />
                  <Route path={`/${analyticRoutes.advertising}/*`} element={
                    <AnalyticsPage
                      activeSubItems={activeSubItems}
                      route={analyticRoutes.advertising}
                    />
                  }
                  />

                  <Route path={`/${analyticRoutes.ordersAndSales}/*`} element={
                    <AnalyticsPage
                      activeSubItems={activeSubItems}
                      route={analyticRoutes.ordersAndSales}
                    />
                  }
                  />

                  <Route
                    path={`/${analyticRoutes.prices}/*`} element={
                      <AnalyticsPage
                        activeSubItems={activeSubItems}
                        route={analyticRoutes.prices}
                      />
                    }
                  />

                  <Route path={`/${analyticRoutes.stock}/*`} element={
                    <AnalyticsPage
                      activeSubItems={activeSubItems}
                      route={analyticRoutes.stock}
                    />
                  }
                  />

                  <Route path={`/${analyticRoutes.abc}/*`} element={
                    <AnalyticsPage
                      activeSubItems={activeSubItems}
                      route={analyticRoutes.abc}
                    />
                  }
                  />

                  <Route path={`/${analyticRoutes.returnAndCancellations}/*`} element={
                    <AnalyticsPage
                      activeSubItems={activeSubItems}
                      route={analyticRoutes.returnAndCancellations}
                    />
                  }
                  />

                  <Route path={`/${analyticRoutes.lowHigh}/*`} element={
                    <AnalyticsPage
                      activeSubItems={activeSubItems}
                      route={analyticRoutes.lowHigh}
                    />
                  }
                  />

                  <Route path={`/${analyticRoutes.brand_report}/*`} element={
                    <AnalyticsPage
                      activeSubItems={activeSubItems}
                      route={analyticRoutes.brand_report}
                    />
                  }
                  />

                  <Route path={`/${analyticRoutes.slices}/*`} element={
                    <AnalyticsPage
                      activeSubItems={activeSubItems}
                      route={analyticRoutes.slices}
                    />
                  }
                  />

                  {/* Товары */}

                  <Route path="/competitors/*" element={<ViewСompetitors />} />

                  <Route path="/add-product/*" element={<AddProductVer3 />} />

                  <Route path="/edit-product/*" element={<EditProduct />} />

                  <Route path="/products_list" element={<ProductsList />} />

                  <Route path="/analysis_mp_product/*" element={
                    <ProductCardExtended
                      content={'mp_product'}
                      title={'Анализ по '}
                    />}
                  />

                  {/* Мастер товары */}

                  <Route path="/content-transfer/*" element={
                    <ProductsListMasterProduct
                      isModalActive={isModalActive}
                      setIsModalActive={(e) => setIsModalActive(e)}
                      transfer={true}
                    />
                  }
                  />

                  <Route path="set-price-and-margin" element={<SetPriceAndMargin />} />

                  <Route path="/set-remaining-goods" element={<SetRemainingGoods />} />

                  <Route path="/mass-improvement/*" element={<MassImprovement />} />

                  <Route path="/setting-cost-price/*" element={<SettingCostPrice />} />

                  <Route path="/checking-OVH/*" element={<CheckingOVH />} />

                  {/* Конкуренты */}

                  <Route path="/view-competitors/*" element={< ViewСompetitors2 />} />

                  <Route path="/add-competitors/*" element={<AddCompetitors />} />

                  {/* Мастер товары */}

                  <Route path="/products_list_master_product/*" element={
                    <ProductsListMasterProduct
                      isModalActive={isModalActive}
                      setIsModalActive={(e) => setIsModalActive(e)}
                    />
                  } />

                  <Route path="/setting-master-product" element={<SettingMasterProduct />} />

                  <Route path="set-price-and-margin-master-product/*" element={<SetPriceAndMarginMasterProduct />} />

                  <Route path="/set-remaining-goods-master-product/*" element={<SetRemainingGoodMasterProduct />} />

                  <Route path="/analysis_sku/*" element={<ProductCardExtended content="master-product" title="Анализ по " />} />

                  <Route path="/calculation-delivery" element={<CalculationDelivery />} />

                  {/* Конкуренты */}

                  <Route path="analysis-by-SKU/*" element={window.location.pathname.includes('search')
                    ?
                    <SkuSearch />
                    :
                    <ProductCardExtended content="" title="Анализ по " />}
                  />

                  <Route path="analysis-category/*" element={<AnalysisCategory />} />

                  <Route path="niche-search/*" element={<NicheSelection />} />

                  <Route path="analysis-by-brand/*" element={<AnalysisPlatformByBrand />} />

                  <Route path="analysis-by-sellers/*" element={<AnalysisPlatformBySellers />} />

                  <Route path="analysis-by-sale-type/*" element={<AnalysisBySaleType />} />

                  {/* Заказы */}

                  <Route path="/order-management/*" element={<OrderManagement />} />

                  <Route path="/deliveries/*" element={<Deliveries />} />

                  {/* Возвраты */}

                  <Route path="/supply-list/*" element={<SupplyList />} />

                  {/* Биддер */}

                  <Route path="/marketing-place/*" element={<MarketingOzon />} />

                  <Route path="/out-marketing-place/*" element={<MarketingOzon />} />

                  <Route path="/installation-DRR/*" element={<InstallationDRR />} />

                  <Route path="/create-campaign-from-rules" element={<CreateCampaignFromRules />} />

                  <Route path="/analytics-by-metrics/*" element={<AnalyticsByMetrics />} />

                  <Route path='low-high_analysis/*' element={<LowHighAnalysis />} />

                  {/* Документы */}

                  <Route path="/act1" element={<Invoice />} />

                  <Route path="/act2" element={<ActService />} />

                  <Route path="/act3" element={<ActVerification />} />

                  <Route path="/act4" element={<InvoiceWithSignature />} />

                  <Route path="/act5" element={<Invoice />} />

                  {/* Акции */}

                  <Route path="/marketing-place/promotions/*" element={<PromotionsPage route="promotions" />} />

                  <Route path="/strategy-promotion/*" element={<Rules />} />

                  {/* Репрайсинг */}

                  <Route path="/repricing/*" element={<Repricing />} />

                  <Route path="/maintaining-marginality" element={<MaintainingMarginality />} />

                  {/* Возвраты */}

                  <Route path="/working-with-returns" element={<WorkingWithReturns />} />

                  <Route path="/automation-returns" element={<AutomationReturns />} />

                  {/* Автозаполнение шаблонов ИИ */}

                  <Route path="/autocomplete-templates-ai/*" element={<AutocompleteTemplatesAi />} />

                  {/* Ключевые слова */}

                  <Route path="analysis-search-query/*" element={<AnalysisSearchQuery />} />

                  <Route path="keywords/analysis-by-SKU/*" element={<ProductCardExtended content="keyword" title="Анализ по " />} />

                  <Route path="analysis-by-category/*" element={<AnalysisByCategory />} />

                  <Route path="/keywords/analysis-by-brand/*" element={<AnalysisByBrand />} />

                  <Route path="/keywords/analysis-by-sellers/*" element={<AnalysisBySellers />} />

                  <Route path="top-keywords" element={<TopKeywords />} />

                  {/* Отзывы и вопросы */}
                  <Route path="work-with-review/*" element={
                    <WorkWithReviews
                      openConnectionModalById={openConnectionModalById}
                      isModalActive={isModalActive}
                      queryFeddbacks={queryFeddbacks}
                      setQueryFeedbacks={setQueryFeedbacks}
                    />
                  }
                  />

                  <Route path="AI_analysis/*" element={
                    <AIAnalysis
                      openConnectionModalById={openConnectionModalById}
                      pageValue='feedbacks'
                      isModalActive={isModalActive}
                      setQueryFeedbacks={setQueryFeedbacks}
                      setIsModalKnowledgeBase={setIsModalKnowledgeBase}
                    />
                  }
                  />

                  <Route
                    path="analitics-review-feedbacks/*" element={
                      <AnaliticsReview
                        openConnectionModalById={openConnectionModalById}
                        pageValue='feedbacks'
                        isModalActive={isModalActive}
                        setQueryFeedbacks={setQueryFeedbacks}
                        setIsModalKnowledgeBase={setIsModalKnowledgeBase}
                      />
                    }
                  />

                  <Route path="analitics-review-questions/*" element={
                    <AnaliticsReview
                      openConnectionModalById={openConnectionModalById}
                      pageValue='questions'
                      isModalActive={isModalActive}
                      setQueryFeedbacks={setQueryFeedbacks}
                      setIsModalKnowledgeBase={setIsModalKnowledgeBase}
                    />
                  }
                  />

                  <Route path="automation-of-responses/*" element={
                    <AutomationResponses
                      page='feedbacks'
                      setQueryFeedbacks={setQueryFeedbacks}
                      openConnectionModalById={openConnectionModalById}
                    />
                  }
                  />

                  <Route path="automation-of-questions/*" element={
                    <AutomationResponses
                      page='questions'
                      setQueryFeedbacks={setQueryFeedbacks}
                      openConnectionModalById={openConnectionModalById}
                    />
                  }
                  />

                  <Route path="/statistics/*" element={<StatisticsInReviews />} />

                  <Route path="/anomalies/*" element={<Anomalies />} />

                  {/* Социальные сети */}
                  <Route path="/social-network/*" element={<SocialNetwork
                    setIsModalCreatingNewSpace={setIsModalCreatingNewSpace}
                    setIsEditSpace={setIsEditSpace}
                  />} />

                  {/* Задачи */}
                  <Route path="/tasks/*" element={<TaskPage />} />

                  {/* Календарь */}
                  <Route path="/calendar/*" element={<Calendar />} />

                  {/* CRM */}
                  <Route path="/crm/*" element={<CRMPage />} />

                  {/* Ticket */}
                  <Route path="/ticket/*" element={<TicketPage />} />

                  {/* Чат бот */}
                  <Route path="/chat-bot/*" element={<ChatBot />} />

                  {/* Wiki */}
                  <Route path="wiki/*" element={
                    <Wiki
                      activeLang={activeLang}
                      pathBread={pathBread}
                      currentArticle={currentArticle}
                      setCurrentArticle={setCurrentArticle}
                      pathsWebName={pathsWebName}
                      setPathsWebName={setPathsWebName}
                      description={description}
                      setDescription={setDescription}
                      setPaths={setPaths}
                      paths={paths}
                    />
                  } />

                  {/* Файлы */}
                  <Route path="file/*" element={
                    <MainDirectory
                      activeLang={activeLang}
                      pathBread={pathBread}
                      currentArticle={currentArticle}
                      setCurrentArticle={setCurrentArticle}
                      pathsWebName={pathsWebName}
                      setPathsWebName={setPathsWebName}
                      description={description}
                      setDescription={setDescription}
                      setPaths={setPaths}
                      paths={paths}
                      directory={true}
                    />
                  } />

                  {/* Test */}
                  <Route path="test" element={<Test />} />

                  {/* Страница в разработке */}
                  <Route path="not-active" element={<NotActive />} />

                  {/* 404 */}
                  <Route path="/*" element={<Page404 />} />

                  {/* Тариф активен */}
                  <Route path="tariff-not-active" element={<TariffNotActive />} />

                  {/* Подсказочник */}
                  <Route path="/hint/*" element={<Hint />} />

                  <Route path="/cross-analytics/*" element={<CrossAnalytics page={true} />} />

                  <Route path="/service/*" element={<NotificationsVer2 />} />

                  <Route path="/product-card" element={<ProductCardExtended />} />

                </Routes>
              </div>
            </NotificationContext.Provider>
          </div>

          {isModalActive &&
            <Modal
              optionList={spaceList}
              selectedSpace={selectedSpace}
              setSelectedSpace={setSelectedSpace}
              setIsModalFeedback={setIsModalFeedback}
              setIsModalActive={setIsModalActive}
              showAddConnectionModal={connectedModal}
              setConnectedModal={setConnectedModal}
              connectionIds={connectionIds}
              setConnectionIds={setConnectionIds}
            />}

          {(isModalChat && path['*'] !== 'chat') && <ChatModal
            setIsModalChat={setIsModalChat}
          />}

          {(!isModalChat && (path['*'] !== 'chat') && (path['*'] !== 'chat-bot')) && <WidgetChat
            setIsModalChat={setIsModalChat}
          />}

        </ConnectionsContext.Provider>
      </main>

      <Footer />

      {/* Уведомление - подсказка */}

      <SnackbarMui />
    </>
  );
}

export const NotificationContext = createContext(false);
export const ConnectionsContext = createContext(false);

export default App;
